import React from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router";
import { Link } from "react-router-dom";

const TableTypeButtons = () => {
  const location = useLocation();
  const currentTable = location.pathname.split("/")[2]; // "green", "yellow", "red"

  const tableColors: any = {
    green: {
      label: "Tableau Vert",
      bg: "bg-green-100",
      border: "border-l-green-500", // only left border
      button: "bg-green-600 hover:bg-green-700",
    },
    yellow: {
      label: "Tableau Jaune",
      bg: "bg-yellow-100",
      border: "border-l-yellow-500", // only left border
      button: "bg-yellow-600 hover:bg-yellow-700",
    },
    red: {
      label: "Tableau Rouge",
      bg: "bg-red-100",
      border: "border-l-red-500", // only left border
      button: "bg-red-600 hover:bg-red-700",
    },
  };

  const { t } = useTranslation();

  return (
    <div className="my-6">
      <div
        className={`p-4 border-l-8 rounded-lg ${tableColors[currentTable]?.border}`}
      >
        <h2 className="text-xl font-semibold text-gray-800 mb-4">
          {t("Choisissez un tableau")}
        </h2>
        <div className="flex flex-wrap gap-3">
          {["green", "yellow", "red"].map((key) => (
            <Link
              key={key}
              to={`/ordre_table/${key}`}
              className={`px-4 py-2 rounded-md border font-medium transition-all duration-200 ${
                currentTable === key
                  ? `${tableColors[key].button} text-white`
                  : "bg-white text-gray-700 border-gray-300 hover:bg-gray-50"
              }`}
            >
              {t(tableColors[key].label)}
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TableTypeButtons;
